export default __webpack_public_path__ + "static/media/celebrate.65b5444383d3267b25ff24961fce42e3.svg";